(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('Vendor/jquery'), require('Vendor/@openmind/litelog')) :
	typeof define === 'function' && define.amd ? define(['Vendor/jquery', 'Vendor/@openmind/litelog'], factory) :
	(global.GoogleSearch = factory(global.$,global.Logger));
}(this, (function ($,Logger) { 'use strict';

$ = $ && $.hasOwnProperty('default') ? $['default'] : $;
Logger = Logger && Logger.hasOwnProperty('default') ? Logger['default'] : Logger;

var Log = new Logger("StoreLocator/Search");
var Search = function Search(provider, element) {
    this.provider = provider;
    this.$element = $(element);
    this.options = $.extend(true, this.DefaultOptions || {}, provider.options);
    return this;
};
Search.prototype.search = function search (str) {
    return str;
};
Search.prototype.store = function store (str) {
    Log.warn("`store` method is not implemented yet");
};

var Log$1 = new Logger("StoreLocator/GoogleSearch");
var GoogleSearch = (function (Search$$1) {
    function GoogleSearch(provider, element, options) {
        var this$1 = this;

        Search$$1.call(this, provider, element);
        var p = new Promise(function (resolve, reject) {
            this$1.autocomplete = new google.maps.places.Autocomplete(this$1.$element[0], $.extend(true, {}, options || {}));
            this$1.autocomplete.addListener('place_changed', function () {
                var result = this$1.autocomplete.getPlace();
                if (result.place_id) {
                    this$1.provider.trigger('change-address', result.formatted_address, {
                        lat: result.geometry.location.lat(),
                        lng: result.geometry.location.lng(),
                        bounds: JSON.parse(JSON.stringify(result.geometry.viewport)),
                        _type: [google.maps.GeocoderLocationType.RANGE_INTERPOLATED,
                            google.maps.GeocoderLocationType.ROOFTOP].indexOf(result.types[0]) > -1 ? this$1.provider.AddressType.PointOnMap : this$1.provider.AddressType.Generic
                    });
                } else {
                    this$1.provider.navigate(result.name).then(function () {}, function () {
                        this$1.provider.trigger('change-address', result.name, null);
                    });
                }
            });
            this$1.Search = new google.maps.places.AutocompleteService();
            resolve(this$1);
        });
        return p;
    }

    if ( Search$$1 ) GoogleSearch.__proto__ = Search$$1;
    GoogleSearch.prototype = Object.create( Search$$1 && Search$$1.prototype );
    GoogleSearch.prototype.constructor = GoogleSearch;

    var prototypeAccessors = { DefaultOptions: { configurable: true } };
    prototypeAccessors.DefaultOptions.get = function () {
        return {};
    };

    GoogleSearch.prototype.search = function search (str) {
        var this$1 = this;

        return new Promise(function (resolve, reject) {
            this$1.Search.getPlacePredictions({
                input: str,
                types: ['geocode']
            }, function (predictions, status) {
                Log$1.l("Results", predictions);
                predictions = predictions || [];
                var result = [];
                predictions.forEach(function (prediction) {
                    result.push({
                        main: prediction.structured_formatting ? prediction.structured_formatting.main_text : prediction.description,
                        other: prediction.structured_formatting ? prediction.structured_formatting.secondary_text : ""
                    });
                });
                resolve(result);
            });
        });
    };

    Object.defineProperties( GoogleSearch.prototype, prototypeAccessors );

    return GoogleSearch;
}(Search));

return GoogleSearch;

})));
